/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

import { Configuration, PopupRequest } from "@azure/msal-browser";
import  config  from './env.json';

// Config object to be passed to Msal on creation
export const msalConfig: Configuration = {
    auth: {
        clientId:config.REACT_APP_AD_CLIENTID as string,
        authority:config.REACT_APP_AD_AUTHORITY as string,
        redirectUri: config.REACT_APP_AD_REDIRECT_URL as string,
        postLogoutRedirectUri: "/"
    }
};

// Add here scopes for id token to be used at MS Identity Platform endpoints.
export const loginRequest: PopupRequest = {
    scopes: ["User.Read"]
      
};

// Add here the endpoints for MS Graph API services you would like to use.
export const graphConfig = {
    graphMeEndpoint: config.REACT_APP_GRAPHME_ENDPOINT as string
};

